import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import { getAddAssetForm, getAddTagForm, getAssetDelegate, getRelationship, getTagDelegate } from "../util/Context.js";
import WizardModal from "./WizardModal.js";
import { getAssetType, isAssetPaired } from "../util/Relationship.js";
import SearchFilter from "../util/SearchFilter.js";
const {
  t
} = I18N.ns('pairing.pairing.views');
export default {
  create(opts) {
    const {
      id,
      matches,
      uiAttribute: attribute,
      layout,
      relationship,
      appearance: optsAppearance = {}
    } = opts;
    const {
      parentBlueprint,
      blueprint,
      parentRelationship
    } = relationship;
    const {
      targetBlueprint
    } = attribute.source?.attribute || {};
    const parentAttribute = Attributes.getAttribute(`${targetBlueprint.type}.${attribute.source?.attribute?.model?.childPath}`, targetBlueprint.type);
    function getName(data) {
      const {
        context
      } = data;
      let name = t('pairOrUnpair', {
        blueprintName: blueprint.name
      });
      const target = Context.getTargetOfType(context, parentBlueprint.type);
      if (target) {
        const devName = Attributes.get('name', target);
        if (isAssetPaired(target, relationship)) {
          name = t('unpairFrom', {
            blueprintName: blueprint.name,
            devName
          });
        } else {
          name = t('pairTo', {
            blueprintName: blueprint.name,
            devName
          });
        }
      }
      return name;
    }
    return {
      id,
      matches,
      layout,
      appearance: context => {
        if (typeof optsAppearance === 'function') {
          return optsAppearance(context);
        }
        return {
          name: getName(context)
        };
      },
      handles: context => {
        const rel = getRelationship(context);
        if (!rel || !parentRelationship || rel.path !== parentRelationship.path) {
          return false;
        }
        const targets = Context.getTargetsOfType(context, parentBlueprint.type);
        return !targets || targets.length === 1;
      },
      perform: ({
        context
      }) => {
        const {
          clientProps
        } = context;
        const assetDelegate = getAssetDelegate(context, parentRelationship);
        const tagDelegate = getTagDelegate(context, relationship);
        const filters = SearchFilter.create(relationship);
        const target = Context.getTargetOfType(context, getAssetType(relationship));
        const AddAssetForm = getAddAssetForm(context, relationship);
        const AddTagForm = getAddTagForm(context, relationship);
        Dialogs.show({
          component: WizardModal,
          props: {
            AddAssetForm,
            AddTagForm,
            assetDelegate,
            attribute,
            clientProps,
            filters,
            parentAttribute,
            parentRelationship,
            relationship,
            tagDelegate,
            target
          }
        });
      }
    };
  }
};